/******************************************************************************
 * Copyright © 2018 Apollo Foundation                                         *
 *                                                                            *
 ******************************************************************************/

import { combineReducers } from 'redux';
import officialStatement from './main/reducer';
import transactions from './transactions/reducer';
import general from './general/reducer';
import blocks from './blocks/reducer';
import account from './account/reducer';
import genesisBalances from './genesisBalances/reducer';
import peers from './peers/reducer';
import currency from './currency/reducer';

export default combineReducers({
  officialStatement,
  transactions,
  genesisBalances,
  general,
  blocks,
  account,
  peers,
  currency,
});
